import throttle from 'lodash/throttle';

const locationSidebarToggleButton = document.querySelector(
	'.block-location-sidebar-content__sidebar-selected'
);
const locationSidebarDropdown = document.getElementById('locationAnchorLinks');
const locationSidebarDropdownLis =
	locationSidebarDropdown?.querySelectorAll('li');
const locationSidebarDropdownLinks =
	locationSidebarDropdown?.querySelectorAll('a');

const toggleLocationSidebarDropdown = (dropdown, e) => {
	const button = e.target;
	const isExpanded = button.getAttribute('aria-expanded') === 'true';

	button.setAttribute('aria-expanded', !isExpanded);
	dropdown.setAttribute('aria-hidden', isExpanded);

	if (button.getAttribute('aria-expanded') === 'true') {
		document.addEventListener('click', closeLocationSidebarDropdown);
		e.stopPropagation();
	} else {
		document.removeEventListener('click', closeLocationSidebarDropdown);
		e.stopPropagation();
	}
};

const closeLocationSidebarDropdown = () => {
	locationSidebarToggleButton.setAttribute('aria-expanded', 'false');
	locationSidebarDropdown.setAttribute('aria-hidden', 'true');
	document.removeEventListener('click', closeLocationSidebarDropdown);
};

const updateLocationSidebar = () => {
	if (window.matchMedia('(max-width: 991px)').matches) {
		if (!locationSidebarDropdown.getAttribute('aria-hidden')) {
			locationSidebarDropdown.setAttribute('aria-hidden', 'true');
		}
	} else {
	}
};

locationSidebarToggleButton?.addEventListener('click', (e) => {
	toggleLocationSidebarDropdown(locationSidebarDropdown, e);
});

locationSidebarDropdownLinks?.forEach((link) => {
	link.addEventListener('click', (e) => {
		const parentLi = e.target.closest('li');
		const text = e.target.innerText;

		locationSidebarDropdownLis?.forEach((li) =>
			li.classList.remove('active')
		);

		locationSidebarToggleButton.innerText = text;
		parentLi.classList.add('active');
	});
});

window.addEventListener(
	'resize',
	throttle(() => {
		updateLocationSidebar();
	}, 200)
);

window.addEventListener('DOMContentLoaded', updateLocationSidebar);
